export const fetchPullRequestsData = async ({
  proxyUrl,
  token,
  pathname,
  query,
}: {
  proxyUrl: string;
  token?: string;
  pathname: string;
  query?: string; // e.g., "?state=closed&base=main"
}) => {
  const url = `${proxyUrl}/repos/${pathname}/pulls${query ?? ''}`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  return data;
};

export const fetchMergedPRsAfterCommit = async ({
  proxyUrl,
  token,
  pathname,
  baseBranch,
  sinceCommit,
}: {
  proxyUrl: string;
  token?: string;
  pathname: string;
  baseBranch: string;
  sinceCommit: string;
}) => {
  const prs = await fetchPullRequestsData({
    proxyUrl,
    token,
    pathname,
    query: `?state=closed&base=${baseBranch}&sort=updated&direction=desc`,
  });

  const mergedPRs = prs.filter(
    (pr: any) => pr.merged_at && pr.merge_commit_sha,
  );

  const relevantPRs: any[] = [];

  for (const pr of mergedPRs) {
    const compareResponse = await fetch(
      `${proxyUrl}/repos/${pathname}/compare/${sinceCommit}...${pr.merge_commit_sha}`,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      },
    );

    const compareData = await compareResponse.json();

    // The compare API returns "ahead" if pr.merge_commit_sha includes commits after sinceCommit
    if (compareData.status === 'ahead') {
      relevantPRs.push(pr);
    }
  }

  return relevantPRs;
};
